import {
    Button, IconButton, InputAdornment, TextField
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import icone from "../../../assets/images/support_logo.png";
import { actionCadastrarNovaSenha } from "../../../store/actions/usuario";
  
  import { Box, Formulario, Home } from "../styles";
  
  function SenhaLinkRecebido() {

    const { hash } = useParams()
    const dispatch = useDispatch();
    const [showPass, setShowPass] = useState(false);
    const { loadResetSenha } = useSelector((state) => state.usuario)
    function ShowPassword() {
      setShowPass(showPass ? false : true);
    }
  
    const navigate = useNavigate();
  
    const [data, setData] = useState({ email: "", password: "" });
  
    async function sendLogin(event) {
      event.preventDefault();
      try {
        await actionCadastrarNovaSenha(hash, {password: data.password});
        console.log("Login ok");
        navigate("/login", { replace: true });
      } catch (error) {
        console.log(error);
      }
    }
  
    return (
      <Home>
        <Box>
          <div style={{ textAlign: "center", padding: "1em" }}>
            <img src={icone} style={{ width: "150px", marginTop: 10 }} />
          </div>
          <h4 style={{ textAlign: "center" }}>Digite a nova Senha</h4>
  
          <Formulario onSubmit={sendLogin}>
            <label>
            <div>
              <TextField
                type={showPass ? "text" : "password"}
                value={data.password}
                onChange={(event) =>
                  setData({
                    ...data,
                    password: event.target.value,
                  })
                }
                id="password"
                label="Senha"
                fullWidth
                InputLabelProps={{ shrink: true }}
                margin="dense"
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ cursor: "Pointer", opacity: "0.7" }}
                      onClick={ShowPassword}
                    >
                      <IconButton onClick={ShowPassword}>
                        {showPass ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>          
            </label>
            <br />
            <div>
            {loadResetSenha ? 
              <Button variant="outlined" fullWidth disabled="true" color="primary">
                Aguarde...
              </Button>
              :
              <Button variant="outlined" fullWidth type="submit" color="primary">
                CADASTRAR NOVA SENHA
              </Button>
  }
            </div>
            <br />
          </Formulario>
          <div style={{ paddingBottom: "2em", textAlign: "center" }}>
  
          </div>
        
          <br />
        </Box>
      </Home>
    );
  }
  
  export default SenhaLinkRecebido;
  